import React, { useEffect, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend
} from "recharts";
import { PrAnalysisApi } from "../../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useTheme,
  CardActions,
  Button,
  IconButton
} from "@mui/material";

import RefreshIcon from '@mui/icons-material/Refresh';


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

const Tab8ChartContent = () => {
  const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
  const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
  const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

  const [chartData, setChartData] = useState([]);
  const [chartData2, setChartData2] = useState([]);
  const [chartData3, setChartData3] = useState([]);
  const [chartData4, setChartData4] = useState([]);
  const [chartData5, setChartData5] = useState([]);
  const [chartData6, setChartData6] = useState([]);
  const theme = useTheme();
  const { palette, spacing, shape: { borderRadius } } = useTheme()

  // console.log("startdate", StartDate)
  // console.log("enddate", EndDate)
  const credentials = {
    USER: localStorage.getItem("LoginID") || "",
    LCODE: localStorage.getItem("LCODE") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "XYZ",
    WEB_KEY: localStorage.getItem("WEB_KEY") || "WEBXYZ321",
    DT1: StartDate, // Default Start Date
    DT2: EndDate, // Default End Date
  };

  // Fetch data from the API
  const fetchLogData = async () => {
    try {
      const res = await PrAnalysisApi(credentials);


      if (res?.data && Array.isArray(res.data)) {
        console.log("Fetched Data:", res.data);

        // Transform the API data of Chart1
        const transformedData = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          PR: parseFloat(item.PR) || 0, // PR value
          CUF: parseFloat(item.CUF) || 0, // CUF value
        }));

        setChartData(transformedData);

        // Transform the API data of chart2
        const transformedData2 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          Solar_Insolation: parseFloat(item.Solar_Insolation) || 0, // PR value
          PR: parseFloat(item.PR) || 0, // CUF value
        }));

        setChartData2(transformedData2);

        // Transform the API data of chart3
        const transformedData3 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          CUF: parseFloat(item.CUF) || 0, // CUF value
        }));

        setChartData3(transformedData3);

        // Transform the API data of chart4
        const transformedData4 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          Specific_Yield: parseFloat(item.Specific_Yield) || 0, // CUF value
        }));

        setChartData4(transformedData4);

        // Transform the API data of chart5
        const transformedData5 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          Expected_Generation: parseFloat(item.Expected_Generation) || 0, // CUF value
        }));

        setChartData5(transformedData5);

        // Transform the API data of chart6
        const transformedData6 = res.data.map((item) => ({
          name: item.DATET || "N/A", // Use `DATET` for labels on X-axis
          ENG: parseFloat(item.ENG) || 0, // PR value
          PR: parseFloat(item.PR) || 0, // CUF value
        }));

        setChartData6(transformedData6);

      } else {
        console.error("Data structure mismatch:", res);
        setChartData([]); // Handle invalid data response
        setChartData2([]); // Handle invalid data response
        setChartData3([]); // Handle invalid data response
        setChartData4([]); // Handle invalid data response
        setChartData5([]); // Handle invalid data response
        setChartData6([]); // Handle invalid data response
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  // Fetch data on component mount
  // useEffect(() => {
  //   fetchLogData();
  // }, [StartDate, EndDate]);

  useEffect(() => {
    fetchLogData();
  }, []);

  // Handle Start Date change
  const handleStartDateChange = (value) => {
    setStartDate(value); // Update the StartDate directly
  };

  // Handle End Date change
  const handleEndDateChange = (value) => {
    setEndDate(value); // Update the EndDate directly
  };


  // Refresh data only when clicking "Show"
  function onRefreshData() {
    if (StartDate.length !== 0 && EndDate.length !== 0) {
      fetchLogData(); // Fetch data only after clicking the button
    } else {
      alert("Please provide valid dates");
    }
  }

  return (

    <>
      <Box bgcolor={"black"} py={0}>

        <Grid container spacing={spacing(0)} flexGrow={1} sx={{ mt: 0,p:0}}>
          <Grid key="chart-grid" item xs={12}>
            <Card>
              <CardActions sx={{
                display: "flex", // Enable flexbox
                justifyContent: "flex-end", // Align items to the right
                alignItems: "center", // Center items vertically
                gap: "16px", // Add some spacing between the inputs
              }}>
                <label>
                  From:&nbsp;
                  <input
                    type="date"
                    value={StartDate} // Use StartDate directly
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <label>
                  To:&nbsp;
                  <input
                    type="date"
                    value={EndDate} // Use EndDate directly
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'black', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
                <IconButton
                  onClick={onRefreshData}
                  sx={{
                    color: 'black',
                    // backgroundColor: palette.tintBlue,
                    borderRadius: borderRadius,
                    p: 1, // Adjust padding if needed
                  }}
                >
                  <RefreshIcon sx={{ fontSize: '24px' }} />
                </IconButton>

              </CardActions>
            </Card>
          </Grid>


        </Grid>




        <Grid container spacing={1} flexGrow={1} sx={{ mt: 0 }}>

          <Grid item xs={12} md={6}>
            <Card>
              {/* Heading Box using Material UI Box */}
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                Energy Generation[KWh]
              </Box>

              <CardContent sx={{ padding: "0px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData3}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                      <XAxis
                        dataKey="name"
                        stroke="black" // ✅ axis line and ticks
                        tick={{ fill: "black" }} // ✅ tick text color
                      />
                      <YAxis
                        yAxisId="left"
                        stroke="black"
                        tick={{ fill: "black", fontSize: 12 }}
                        label={{
                          value: "ENG",
                          angle: -90,
                          position: "insideLeft",
                          fill: "black", // ✅ label color

                        }}
                      />
                      <Tooltip
                        contentStyle={{ backgroundColor: "#333", border: "none" }}
                        labelStyle={{ color: "black" }}
                        itemStyle={{ color: "black" }}
                      />
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px",
                          color: "black", // ✅ legend label color
                        }}
                      />

                      <Bar
                        dataKey="ENG"
                        fill={LoggedInUserInfo.dash_color}
                        name="Energy Generation"
                        yAxisId="left"
                      >
                        <LabelList
                          dataKey="ENG"
                          position="top"
                          style={{
                            fill: LoggedInUserInfo.dash_color,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    textAlign="center"
                  >
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>



            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              {/* Heading Box using Material UI Box */}
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                CUF Curve
              </Box>

              <CardContent sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData3}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
                      <XAxis dataKey="name"
                        stroke="black" // ✅ axis line and ticks
                        tick={{ fill: "black" }} // ✅ tick text color
                      />
                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        stroke="black"
                        label={{
                          value: "CUF",
                          angle: 90,
                          position: "insideRight",
                          fill: "black", // ✅ label color


                        }}
                      />
                      <Tooltip />
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px",
                          fontSize: "12px",
                          color: "black", // ✅ legend label color

                        }}
                      />

                      {/* CUF as Bar Graph */}
                      <Bar
                        dataKey="CUF"
                        fill={LoggedInUserInfo.dash_color}
                        name="CUF"
                        yAxisId="right"
                      >
                        <LabelList
                          dataKey="CUF"
                          position="top"
                          style={{
                            fill: LoggedInUserInfo.dash_color,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>
                    </ComposedChart>
                  </ResponsiveContainer>


                ) : (
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    textAlign="center"
                  >
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>


            </Card>
          </Grid>



        </Grid>


      </Box>





      <Box bgcolor={"black"} py={0}>

        <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 0 }}>
          <Grid key="chart-grid" item xs={12}>
            <Card>
              <CardActions sx={{
                display: "flex", // Enable flexbox
                justifyContent: "flex-end", // Align items to the right
                alignItems: "center", // Center items vertically
                gap: "16px", // Add some spacing between the inputs
              }}>
                <label>

                  <input
                    type="date"
                    value={StartDate} // Use StartDate directly
                    onChange={(e) => handleStartDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                <label>
                  To
                  <input
                    type="date"
                    value={EndDate} // Use EndDate directly
                    onChange={(e) => handleEndDateChange(e.target.value)}
                    style={{
                      padding: "2px 2px",
                      borderRadius: "14px",
                      border: "1px solid #ccc",
                    }}
                  />
                </label>
                {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'black', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
                <IconButton
                  onClick={onRefreshData}
                  sx={{
                    color: 'black',
                    // backgroundColor: palette.tintBlue,
                    borderRadius: borderRadius,
                    p: 1, // Adjust padding if needed
                  }}
                >
                  <RefreshIcon sx={{ fontSize: '24px' }} />
                </IconButton>

              </CardActions>
            </Card>
          </Grid>


        </Grid>




        <Grid container spacing={1} flexGrow={1} sx={{ mt: 0 }}>
          <Grid item xs={12} md={6}>
            <Card>
              {/* Heading Box using Material UI Box */}
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                Energy Generation[KWh] Vs. CUF Curve
              </Box>

              <CardContent sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData3}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name"
                        stroke="black" // ✅ axis line and ticks
                        tick={{ fill: "black" }} // ✅ tick text color
                      />
                      <YAxis
                        yAxisId="left"
                        stroke="black" // ✅ axis line and ticks
                        label={{
                          value: "ENG",
                          angle: -90,
                          position: "insideLeft",
                          fill: "black"
                        }}
                      />
                      <YAxis
                        yAxisId="right"
                        stroke="black" // ✅ axis line and ticks

                        orientation="right"
                        label={{
                          value: "CUF",
                          angle: 90,
                          position: "insideRight",
                          fill: "black"
                        }}
                      />
                      <Tooltip />

                      {/* Add Legend */}
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px", // Space between legend and chart
                          fontSize: "12px", // Adjust font size
                        }}
                      />

                      {/* ENG Bar */}
                      <Bar
                        dataKey="ENG"
                        fill={LoggedInUserInfo.dash_color}
                        name="Energy Generation" // Legend label for ENG
                        yAxisId="left"
                      >
                        <LabelList
                          dataKey="ENG"
                          position="top"
                          style={{
                            fill: LoggedInUserInfo.dash_color,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>

                      {/* CUF Line */}
                      <Line
                        type="monotone"
                        dataKey="CUF"
                        stroke="red"
                        name="CUF" // Legend label for CUF
                        yAxisId="right"
                      >
                        <LabelList
                          dataKey="CUF"
                          position="top"
                          style={{
                            fill: "red",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Line>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    textAlign="center"
                  >
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>


            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              {/* Heading Box using Material UI Box */}
              <Box
                sx={{
                  padding: "4px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                  textAlign: "start",
                  fontWeight: "bold",
                  fontSize: "16px",
                  border: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaCrosshairs style={{ marginRight: '10px', color: 'black' }} />
                Energy Generation[KWh] Vs. Specific Yield
              </Box>

              <CardContent sx={{ padding: "2px" }}>
                {chartData3.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart
                      data={chartData4}
                      margin={{ top: 10, right: 10, left: 10, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name"
                        stroke="black" // ✅ axis line and ticks
                        tick={{ fill: "black" }} // ✅ tick text color
                      />
                      <YAxis
                        yAxisId="left"
                        stroke="black"
                        label={{
                          value: "ENG",
                          angle: -90,
                          position: "insideLeft",
                          fill: "black"
                        }}
                      />
                      <YAxis
                        yAxisId="right"
                        stroke="black"
                        orientation="right"
                        label={{
                          value: "Specific_Yield",
                          angle: 90,
                          position: "insideRight",
                          fill: "black"
                        }}
                      />
                      <Tooltip />

                      {/* Add Legend */}
                      <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="center"
                        wrapperStyle={{
                          paddingBottom: "10px", // Space between legend and chart
                          fontSize: "12px", // Adjust font size
                        }}
                      />

                      {/* ENG Bar */}
                      <Bar
                        dataKey="ENG"
                        fill={LoggedInUserInfo.dash_color}
                        name="Energy Generation" // Legend label for ENG
                        yAxisId="left"
                      >
                        <LabelList
                          dataKey="ENG"
                          position="top"
                          style={{
                            fill: LoggedInUserInfo.dash_color,
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Bar>

                      {/* Specific_Yield Line */}
                      <Line
                        type="monotone"
                        dataKey="Specific_Yield"
                        stroke="red"
                        name="Specific_Yield" // Legend label for Specific_Yield
                        yAxisId="right"
                      >
                        <LabelList
                          dataKey="Specific_Yield"
                          position="top"
                          style={{
                            fill: "red",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        />
                      </Line>
                    </ComposedChart>
                  </ResponsiveContainer>
                ) : (
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    textAlign="center"
                  >
                    No data available for the selected range.
                  </Typography>
                )}
              </CardContent>


            </Card>
          </Grid>

        </Grid>


      </Box>






    </>




  );
};

export default Tab8ChartContent;

